export const readFile = (file: Blob, encoding: string): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => {
      const target = event.target as FileReader;
      resolve(target.result as string);
    };
    reader.readAsText(file, encoding);
  }) as Promise<string>;
};

export interface Result {
  text: string;
  encoding: string;
}

export const parse = async (
  file: Blob,
  checkToken?: string
): Promise<Result | undefined> => {
  const encodings = ["utf-16", "utf-8", "shift-jis"];
  for (const encoding of encodings) {
    const text = await readFile(file, encoding);
    if (checkToken && !text.includes(checkToken)) {
      continue;
    }
    return { text, encoding };
  }
};
